import { render, staticRenderFns } from "./HtmxPartial.vue?vue&type=template&id=70f02cf0"
import script from "./HtmxPartial.vue?vue&type=script&lang=js"
export * from "./HtmxPartial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports